import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoaderService} from '../components/spinner/loader.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {LoaderInterceptor} from '../components/spinner/loader-interceptor';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [LoaderService, {
    provide: HTTP_INTERCEPTORS,
    useClass: LoaderInterceptor,
    multi: true
  }]
})
export class LoaderModule { }
